// extracted by mini-css-extract-plugin
module.exports = {"footer":"FileParser_footer__q_LGy"};